<!--产品试用-->
<template>
  <div class="container">
    <div class="marginCon">
      <span class="labelTitle">认证身份：</span>
      <span class="grayCont">{{identity}}</span>
    </div>

    <div class="marginCon">
      <span class="labelTitle">试用期限：</span>
      <span class="grayCont">{{yxstart_time}} - {{yxend_time}}</span>
    </div>

    <div class="marginCon">
      <span class="labelTitle">试用项目数量：</span>
      <span class="grayCont">{{MaxProjectCount}}</span>
    </div>

    <p class="lineStyle"></p>
    <div class="marginCon">
      <span class="labelTitle">社会信用代码：</span>
      <span class="grayCont">{{nsrsbh}}</span>
    </div>
    <div class="marginCon">
      <span class="labelTitle">企业名称：</span>
      <span class="grayCont">{{qymc}}</span>
    </div>
    <div class="marginCon">
      <span class="labelTitle">资质等级：</span>
      <span class="grayCont">{{zzdj}}</span>
    </div>

    <div class="fileOutCon">
      <span class="fileTitle">营业执照副本：</span>
      <div class="fileCon businessCon">
        <div class="viewer" v-viewer="{}">
          <MultiImage
            v-for="(item,index) in businessFiles"
            :loading="false"
            :key="index"
            :index="index"
            :src="item.path"
            :original-src="item.path"
            :del-btn="false"
          >
          </MultiImage>
        </div>
      </div>
    </div>

    <el-dialog
      title="申请正式授权"
      :visible.sync="applyDialog"
      width="800px"
      :close-on-click-modal="false"
      @opened="dialogOpen"
    >
      <div class="dialogCon">
        <hint-input
          name="htbh"
          ref="htbh"
          label="*与协同软件签订的合同编号"
          placeholder="请输入合同编号，用于正式授权审核"
          :cusVerify="htbhCusVerify"
          :value.sync="htbh"
        ></hint-input>

        <div class="marginCon" style="height: 26px !important;">
          <span class="labelTitle"><span class="redReq">*</span>与协同软件签订的合同附件：</span>
          <a class="upLink contractUp">上传附件</a>
          <div v-if="contractMsgShow" class="showText">
            合同附件必须上传
          </div>
        </div>

        <div
          v-if="contractFiles.length != 0"
          class="fileCon contractFileCon">
          <div class="viewer" v-viewer="{}">
            <MultiImage
              v-for="(item,index) in contractFiles"
              :src="item.packSrc"
              :key="item.id"
              :originalSrc="item.orgSrc"
              :loading.sync="item.loading"
              :index="index"
              :adapter="contractFiles"
              @eventCallback="eventCallback"
            ></MultiImage>
          </div>
        </div>

        <a class="applyFormalBtn" @click="goApply">申请正式授权</a>
        <P class="bottom bottomNav">联系客服<a
          :href="'http://wpa.qq.com/msgrd?v=3&uin='+kfqq+'&site=qq&menu=yes'"
          target="_blank"
          class="fontStyle underLine qqStyle">{{kfqq}}</a><span
          class="fontStyle telStyle">{{tel}}</span></P>
      </div>
    </el-dialog>

    <!--提示成功弹出框-->
    <el-dialog
      title="提示"
      :visible.sync="successDialog"
      width="460px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <div class="successDialogCon">
        <p class="dialogTitle">
          提交成功
        </p>
        <p class="dialogCont">您的产品试用申请已提交，我们将于<span class="workDay">3个工作日内</span>进行审核，<br/>审核结果将以短信形式发送，请关注手机信息。
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MultiImage from '@/components/MultiImage'
  import HintInput from '@/components/HintInput'
  import Upload from '../utils/XTUpload.js'

  export default {
    name: 'ProductTrial'
    , data () {
      return {
        // 认证guid
        rz_guid: ''
        // 认证身份
        , identity: '-'
        // 最大使用项目数量
        , MaxProjectCount: '-'
        // 社会信用代码
        , nsrsbh: '-'
        // 企业名称
        , qymc: '-'
        // 资质等级
        , zzdj: '-'
        // 认证申请日期
        , yxstart_time: ''
        // 认证通过日期
        , yxend_time: ''
        // 营业执照副本
        , businessFiles: []
        // 申请正式授权弹窗
        , applyDialog: false
        // 合同编号
        , htbh: ''
        // 上传附件upload
        , contractUpload: null
        , contractMsgShow: true
        , contractFiles: []
        , htbhCusVerify (data, callback) {
          let value = data.value
          if (this.$utils.trim(value).length == 0) {
            callback('合同编号不能为空')
          } else {
            callback('')
          }
          console.log(data)
        }
        , kfqq: this.$global.kfqq
        , tel: this.$global.tel
        , successDialog: false
      }
    }
    , props: {
      common: {
        type: Object
      }
    }
    , components: {
      MultiImage
      , HintInput
    }
    , methods: {
      // 初始化页面数据
      initViewData (result, resultbg) {
        // 认证guid
        this.rz_guid = result.rz_guid
        // 认证身份
        if (result.sqlx == '0') { // 产品试用
          this.identity = '试用身份'
        }
        // 试用期限
        this.yxstart_time = result.yxstart_time
        this.yxend_time = result.yxend_time
        // 使用项目数量
        this.MaxProjectCount = result.MaxProjectCount
        // 社会信用代码
        this.nsrsbh = result.nsrsbh
        // 企业名称
        this.qymc = result.qymc
        // 资质等级
        this.zzdj = result.zzdj
        // 合同编号
        this.htbh = result.htbh
        // 附件过滤
        for (let i = 0; i < resultbg.length; i++) {
          let item = resultbg[i]
            , cloneItem = this.$utils.deepClone(item)

          cloneItem.packSrc = cloneItem.path
          cloneItem.orgSrc = cloneItem.path
          cloneItem.loading = false

          if (item.leixing == 0) {
            this.businessFiles.push(item)
          } else if (item.leixing == 1) {
            this.contractFiles.push(cloneItem)
          }
        }

      }
      , getFormatDate (str) {
        let date = new Date(str)
        return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDay() + '日'
          + date.getHours() + '时' + date.getMinutes() + '分' + date.getSeconds() + '秒'
      }
      // 弹窗显示方法
      , applyDialogShow () {
        this.applyDialog = true
      }
      , getFileFormData (files) {
        let formData = new FormData()
          , nameArr = []
          , idArr = []

        formData.append('fjlx', 1)
        formData.append('rz_guid', this.rz_guid)
        formData.append('UserName', this.$store.getters.getUserName)
        for (let i = 0; i < files.length; i++) {
          let item = files[i]
          formData.append('files', item.blob, item.name)
          nameArr.push(item.name)
          idArr.push(item.id)
        }
        // 设置name集合
        formData.append('fjmcls', JSON.stringify(nameArr))
        formData.append('id', JSON.stringify(idArr))

        return formData
      }
      // 上传error回调
      , uploadError (msg) {
        this.$message({
          message: msg
          , type: 'warning'
        })
      }
      // 照片处理前的回调
      , uploadBeforeDeal () {
        this.curMes = this.$message({
          message: '图片压缩中...'
        })
      }
      // 合同file处理完回调
      , contractAfterDeal (curFiles, allFiles) {
        this.curMes && this.curMes.close()
        this.$message({
          message: '图片压缩成功!'
          , type: 'success'
        })
        console.log(allFiles)
        this.contractFiles = []
        this.contractFiles = allFiles

        // 上传图片
        this.goContractUpload(curFiles, allFiles)
      }
      // 合同执照上传
      , goContractUpload (curFiles, allFiles) {
        var fileFormData = this.getFileFormData(curFiles)
        this.$axios.post('RenZhengHandler.ashx', fileFormData)
          .then((res) => {
            console.log(res)
            let data = res.data
            if (data.isError == 'false') {
              // console.log(allFiles)
              for (let i = allFiles.length - curFiles.length; i < allFiles.length; i++) {
                allFiles[i]['loading'] = false
                allFiles.splice(i, 1, allFiles[i])
              }
              // console.log(this.businessFiles)
              this.$message({
                message: '图片上传成功!'
                , type: 'success'
              })
            } else {
              this.$message({
                message: '图片上传失败,请重试'
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.$message({
              message: '图片上传失败,请重试'
              , type: 'warning'
            })
          })
      }

      // 弹窗打开回调
      , dialogOpen () {
        console.log(123)
        let that = this
        console.log(that.contractUpload)
        // 合同附件
        if (that.contractUpload == null) {
          that.contractUpload = Upload.init('.contractUp')
            .setMaxLimits(10)
            .setAllSize(8)
            .setDataList(that.contractFiles)
            .setBeforeDell(that.uploadBeforeDeal)
            .setAfterDeal(that.contractAfterDeal)
            .setError(that.uploadError)
        }
      }

      // 图片事件返回
      , eventCallback (event) {
        console.log(event)
        if (event.type == 'del') {
          let params = {
            id: event.adapter[event.index].id
          }
          this.$axios.get('UserManager/DeleteFujian', {
            params: params
          })
            .then((res) => {
              let data = res.data
              if (data.isError == 'False') {
                event.adapter.splice(event.index, 1)
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              } else {
                this.$message({
                  type: 'warning',
                  message: '删除失败!'
                })
              }
            })
            .catch((err) => {
              this.$message({
                type: 'warning',
                message: '删除失败!'
              })
            })
        }
      }

      // 点击申请正式授权
      , goApply () {
        let ifPass = true
        if (this.htbh == '') {
          this.$refs.htbh.blur()
          ifPass = false
        }
        if (this.contractFiles.length == 0) {
          this.contractMsgShow = true
          ifPass = false
        }
        if (!ifPass) {
          return
        }

        let params = {
          rz_guid: this.rz_guid
          , htbh: this.htbh
        }
        this.$axios.post('UserManager/UpdateRenZhengHtbh', params)
          .then((res) => {
            let data = res.data
            if (data.isError == 'False') {
              // 试用申请正式 再改变次状态
              this.changeState()
              this.successDialog = true
            } else {
              this.$message({
                message: '申请正式授权失败'
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.$message({
              message: '请求申请正式授权失败,请重试'
              , type: 'warning'
            })
          })
      }
      // 试用申请正式 再请求改变次状态
      , changeState () {
        let params = {
          rz_guid: this.rz_guid
          , zt: 1
          , sqlx: 1
        }
        this.$axios.post('UserManager/SetRzSf', params)
          .then((res) => {
            let data = res.data
            if (data.isError == 'False') {
              this.successDialog = true
            } else {
              this.$message({
                message: '申请正式授权失败'
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.$message({
              message: '请求申请正式授权失败,请重试'
              , type: 'warning'
            })
          })
      }

      // 成功申请弹窗关闭
      , handleClose () {
        this.applyDialog = false
        // this.common.step = 4
        this.common.getDataCallback()
      }
    }
    , computed: {}
    , created () {
      this.initViewData(this.common.result, this.common.resultbg)
      this.common.applyDialogFunc = this.applyDialogShow
    }
    , watch: {
      // 合同附件
      contractFiles (newValue) {
        if (newValue.length != 0) {
          this.contractMsgShow = false
        } else {
          this.contractMsgShow = true
        }
      }
    }
  }
</script>

<style scoped>
  p, div, input {
    overflow: hidden;
    transition: all .3s;
  }

  .marginCon {
    height: 19px !important;
    line-height: 19px !important;
    margin-top: 24px;
    padding: 0px !important;
  }

  .blueState {
    margin-left: 20px;
    font-size: 18px;
    color: #3492FF;
    font-weight: 600;
  }

  .grayCont {
    margin-left: 20px;
    font-size: 14px;
    color: #7F7F7F;
  }

  .lineStyle {
    width: 800px;
    height: 1px;
    background: #EDEDED;
    margin: 32px auto;
  }

  .fileOutCon {
    font-size: 14px;
    color: #000;
    margin-top: 24px;
  }

  .fileTitle {
    display: inline-block;
    width: 417px;
    vertical-align: top;
    text-align: right;
  }

  .businessCon {

  }

  .fileCon {
    margin-top: 10px;
    margin-left: 20px;
  }

  .dialogCon {
    position: relative;
    min-height: 350px;
  }

  .dialogCon >>> .labelStyle {
    width: 314px;
  }

  .dialogCon >>> .inputStyle {
    width: 290px;
  }

  .dialogCon >>> .inputCon {
    margin-top: 30px;
  }

  .dialogCon .labelTitle {
    width: 314px !important;
  }

  .dialogCon .fileCon {
    margin-left: 107px;
    margin-bottom: 136px;
  }

  .dialogCon .showText {
    display: inline-table;
    width: auto;
    height: 24px;
    padding-right: 8px;
    margin-left: 16px;
    line-height: 24px;
    background: #FFF2F2 url("../assets/error.png") no-repeat 7px center;
    border: 1px solid #FFE3E0;
    border-radius: 4px;
    font-size: 13px;
    color: #FF4D4D;
    letter-spacing: 0;
    text-indent: 26px;
  }

  .applyFormalBtn {
    position: absolute;
    display: block;
    width: 240px;
    height: 40px;
    line-height: 40px;
    background: #F5A623;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    bottom: 71px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .upLink {
    color: #04A4FF;
    text-decoration: underline;
  }

  .fontStyle {
    font-size: 13px;
    color: #5599FF;
    text-align: center;

  }

  .underLine {
    text-decoration: underline;
    cursor: pointer;
  }

  .regAgain {
    margin-top: 23px;
    font-size: 14px;
    text-align: center;
  }

  .bottom {
    position: absolute;
    font-size: 14px;
    color: #838383;
    text-align: center;
    bottom: 32px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .qqStyle {
    margin-left: 19px;
    padding-left: 20px;
    background: url("../assets/qq_bg.png") no-repeat left center;
  }

  .telStyle {
    margin-left: 24px;
    padding-left: 20px;
    background: url("../assets/tel_bg.png") no-repeat left center;
  }

  .dialogTitle {
    font-size: 24px;
    color: #5599FF;
    text-align: center;
    line-height: 58px;
    margin-top: 30px;
    font-weight: 600;
  }

  .dialogCont {
    font-size: 14px;
    color: #555555;
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    margin: 16px 38px 0;
  }

  .dialogCont .workDay {
    font-size: 15px;
    color: #3492FF;
    letter-spacing: 0;
  }

  .successDialogCon {
    height: 227px;
  }
</style>



// WEBPACK FOOTER //
// src/page/ProductTrial.vue